import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "../UserContext";

const RoleBasedLanding = () => {
  const { user, loading } = useUser();

  if (loading) return null;
  if (!user) return <Navigate to="/signUp" replace />;

  const ROLE_IDS = {
    USER: "fe42ee60-9133-4f0e-b543-740d8697c23b",
    ADMIN: "ac9be322-db89-4beb-854a-46f2c91de374",
    SUPER_ADMIN: "5aee1e31-cc95-49d9-9ed7-10c4e4b6fdef",
  };

  const role =
    user.role_name ||
    (user.user_role === ROLE_IDS.ADMIN
      ? "Admin"
      : user.user_role === ROLE_IDS.SUPER_ADMIN
        ? "Super Admin"
        : user.user_role === ROLE_IDS.USER
          ? "User"
          : null);

  /* ---------------------------------------------
    🟦 ADMIN / SUPERADMIN
  --------------------------------------------- */
  if (role === "Admin") return <Navigate to="/admin" replace />;
  if (role === "Super Admin") return <Navigate to="/super" replace />;

  /* ---------------------------------------------
    🟪 COACH
  --------------------------------------------- */
  if (role === "Coach") return <Navigate to="/coach" replace />;

  /* ---------------------------------------------
    🟩 ACCOUNTABILITY PARTNER
  --------------------------------------------- */
  if (role === "Accountability Partner") return <Navigate to="/ap" replace />;

  /* ---------------------------------------------
    🟧 LEARNER (ROLE_USER)
  --------------------------------------------- */
  if (role === "User") {
    return <Navigate to="/learner" replace />;
  }

  /* ---------------------------------------------
    Default fallback
  --------------------------------------------- */
  return <Navigate to="/signUp" replace />;
};

export default RoleBasedLanding;
